@if (modalService.activeModal(); as activeModal) {

<div class="modal-backdrop fixed inset-0 z-9998 flex items-center justify-center p-4 overflow-hidden"
  style="background: rgba(0,0,0,0.7); min-height: 100vh;" (click)="onBackdropClick($event)">
  <div class="modal-shell relative z-9999 w-full flex items-center justify-center"
    [class.modal-shell--ticket]="activeModal === 'ticket-transfer'">
    @switch (activeModal) {
    @case ('login') {
    <app-modal-login class="w-full flex justify-center" />
    }
    @case ('registro') {
    <app-modal-register class="w-full flex justify-center" />
    }
    @case ('verificacion') {
    <app-modal-verification class="w-full flex justify-center" />
    }
    @case ('medio-pago') {
    <app-modal-payment-method class="w-full flex justify-center" />
    }
    @case ('tarjeta') {
    <app-modal-payment-method class="w-full flex justify-center" />
    }
    @case ('yape') {
    <app-modal-payment-method class="w-full flex justify-center" />
    }
    @case ('ticket-transfer') {
    <app-modal-ticket-transfer class="w-full flex justify-center" />
    }
    }
  </div>
</div>
}
